import { createAction, props } from '@ngrx/store';
import { Plan } from '@oneqrew-partnertool/models';

export const setFetchedPlans = createAction('[Plans API] Set Fetched Plans', props<{ plans: Plan[] }>());
